const style = `
  /*==========사전등록 페이지==========*/
    .m_slide_con {
      display: none;
    }
    .sch_section {
      padding: 0 20px;
    }
    .sch_wrap {
      display: flex;
      box-sizing: border-box;
      margin-top:30px;
    }
    .sch_wrapper {
      display:flex;
      flex-direction:column;
      row-gap:50px;
      width: calc(100% - 300px);
      padding-right: 30px;
      box-sizing: border-box;
    }
    .bnr_right {
      display:flex;
      flex-direction:column;
      row-gap:12px;
      width: 300px;
      box-sizing: border-box;
    }
    
    /*=====sch_a_con=====*/
    .sch_a_con {
      position: relative;
      box-sizing: border-box;
    }
    .sch_a_con .event_inform{display:flex; flex-direction:column; row-gap:20px;}
    .sch_a_con .event_inform h2{font-size:28px; line-height:36px; font-weight:700; color:#1a1a1a;}
    .sch_a_con .more_btn_span {
      display: inline-block;
      margin-top: 10px;
      padding-left: 1.5px;
      font-size: 13px;
      line-height: 2;
      color: #999999;
      cursor: pointer;
      text-decoration: underline;
    }
    
    .sch_a_con .session_user_list .more_btn_p {
      position: relative;
      font-size: 13px;
      line-height: 1.54;
      text-align: left;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      word-break: break-word;
    }
    .sch_a_con .session_user_list .more_btn_p.on {
      display: block;
      overflow: unset;
    }
    .sch_a_con .more_btn_span small {
      text-decoration: underline;
    }
    
    /*=====sch_b_con=====*/
    .session_list{display:flex; flex-direction:column; gap:40px;}
    .sch_b_con{display:flex; flex-direction:column; gap:20px}
    .sch_b_con:last-child{margin-bottom:0;}
    .sch_wrapper h3 {
      font-size: 22px;
      font-weight: bold;
      text-align: left;
      color: #333333;
    }
    .timeline_h4 {
      display: flex;
      align-items: center;
      flex-basis: 100%;
      font-size: 15px;
      font-weight: bold;
      text-align: left;
      line-height: normal;
      color: #6a6af8;
      margin-bottom: 6px;
      height: 28px;
    }
    
    .timeline_h4:after {
      content: "";
      flex-grow: 1;
      width: auto;
      height: 1px;
      background: #6a6af8;
      font-size: 0;
      line-height: 0;
      margin-left: 10px;
    }
    .livebtn_float {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 3px;
    }
    .livebtn_float .live_time {
      display: inline-block;
      font-size: 20px;
      color: #6a6af8;
      height: 30px;
      line-height: 29px;
      font-weight:bold;
    }
    .livebtn_float .onair_btn {
      margin-right: 4px;
    }
    .sch_b_con .session_name h5 {
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      color: #333333;
      line-height: 1.5;
      word-break:break-word;
    }
    .sch_b_con .more_btn_span {
      display: inline-block;
      font-size: 13px;
      line-height: 2;
      color: #999999;
      cursor: pointer;
      text-decoration: underline;
      width:fit-content;
    }
    .sch_b_con .more_btn_span.on {
      position: unset;
      bottom: auto;
      right: auto;
    }
    .sch_b_con .more_btn_span.on b {
      display: none;
    }
    .sch_b_con .more_btn_span small {font-size:13px;}
    .sch_b_con .pre h4 {
      margin-bottom: 10px;
    }
    .sch_wrapper .basic_btn {
      width:auto;
      min-width:160px;
      padding:5px 10px;
      cursor: pointer;
      font-weight: bold;
      font-size: 14px;
      margin-left:auto;
      min-height:48px;
      line-height:1.4;
      height:unset;
    }
    
    .basic_btn.basic_btn_off {
      background: #ddd;
      cursor: unset;
    }
    .sch_wrapper .ent_span {
      font-size:12px;
      display: inline-block;
      margin-top: 10px;
      word-break:keep-all;
      color: #6a6af8;
    }
    .sch_wrapper .ent_span .time_b {
      display:inline-block;
      font-size:12px;
      margin-right:4px;
      color: #4e4b7b;
    }
    .sch_wrapper .ent_span small {
      font-size:12px;
      color: #666666;
      display: inline-block;
    }
    .sch_wrapper .ent_span span{
      display:block;
      font-size:12px;
      color: #666666;
    }
    .sch_b_con .session_user_list.on {
      display: none;
    }
    .sch_a_con .more_btn_p,.sch_b_con .more_btn_p {
      position: relative;
      font-size: 13px;
      line-height: 1.54;
      text-align: left;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      word-break: break-word;
    }
    .sch_a_con .more_btn_p{margin-top:0;}
    .sch_a_con .more_btn_p.on,.sch_b_con .more_btn_p.on {
      display: block;
      overflow: unset;
    }

    
    .sch_b_con .session_name span {
      display: block;
      font-size: 16px;
      line-height: 1.63;
      text-align: left;
      color: #666666;
    }

    /*태그 리스트*/
    .hashtag_list_cont{display:flex; align-items:center; gap:10px; flex-wrap:wrap;}
    .hashtag_list_cont p{font-size:13px; line-height:18px; font-weight:400; color:#646464; flex-shrink:1;}
    
    .hashtag_list{display:flex; align-items:center; flex-wrap:wrap; gap:5px;}
    .hashtag_list li{border:1px solid #e1e1e1; border-radius:8px; padding:0px 8px; box-sizing:border-box; cursor:pointer; }
    .hashtag_list li span{display:block; font-size:11px; line-height:15px; font-weight:400; padding-bottom:1px; color:#646464 }

    .hashtag_list_cont .hashtag_list li{background:#999999; color:#ffffff; border:1px solid #999999;}
    .hashtag_list_cont .hashtag_list li span{color:#fff;}
    .hashtag_list_cont .hashtag_list li.active {background:#5959EF; border:1px solid #5959EF;}
    @media (hover: hover) {
      .hashtag_list_cont .hashtag_list li:hover{background:#7878FA; border:1px solid #7878FA;}
    }

    /*=====ebooth_banner=====*/
    .ebooth_banner{
      width:100%;
      background:radial-gradient(524.29% 267.58% at 42.17% -33.82%, #2EBCAB 0%, #5959EF 100%);
      border-radius:6px;
      display:flex;
      align-items:center;
      flex-direction:column;
      gap:6px;
      padding:16px 12px;
    }
    .ebooth_banner span{
      font-size:16px;
      font-weight:700;
      line-height:normal;
      color:#fff;
    }
    .ebooth_banner_img{
      width: 100%;
      border-radius: 6px;
      display:block;
      margin-bottom:12px;
      overflow:hidden;
    }
    .ebooth_banner_img img{display:block; width:100%; height:auto;}
    /*=====slide_con=====*/
    .slide_con {position: static;}
    .slide_con:after{content:"";display:block;clear:both;}
    .slide_con .swiper-container {padding-bottom: 30px;}
    .slide_flex{
      display:flex;
      cursor:pointer;
    }
    .slide_flex:nth-child(odd){clear:both;}
    .slide_flex:nth-child(even){padding-right:0;}
    .slide_con_1 .slide_flex{width:100%;}
    .swiper-container .slide_flex { width: auto; margin-right: 0;}
    .slide_flex .slide_flex_div {
      position: relative;
      width: 58px;
      height: 58px;
      margin-right: 10px;
    }
    .slide_flex .slide_flex_t{width:100%; }
    
    .slide_flex .slide_flex_inner_div {
      position: relative;
      width: inherit;
      height: inherit;
    }
    
    .slide_flex .slide_img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color:#D0D0DE;
      border-radius: 50%;
      overflow: hidden;
    }
    .slide_flex .slide_img_more {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 23px;
      height: 23px;
      background-size:cover;
      background-position:center center;
    }
    .slide_flex .slide_flex_t div {display: flex; justify-content: flex-start; margin-bottom: 5px;}
    .slide_flex .slide_flex_t h2 {
      font-size: 14px;
      text-align: left;
      color: #464F60;
      font-weight: 700;
      margin: 2px 0;
      line-height: 20px;
    }
    .slide_flex .slide_flex_t b {
      font-size: 11px;
      display:block;
      height:14px;
      line-height: 14px;
      font-weight: 400;
      color: #464f60;
    }
    
    .slide_flex .slide_flex_t p {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      row-gap: 3px;
      font-size: 11px;
      text-align: left;
      line-height: 14px;
      color: #464F60;
      word-break:break-word;
    }
    .slide_flex .slide_flex_t span {display: inline-block;font-size: 11px;}
    .slide_con .swiper-pagination {bottom: 0;}
    .slide_con .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: #fff;
      border: 2px solid #373779;
      box-sizing: border-box;
      opacity: 1;
    }
    .slide_con .swiper-pagination-bullet-active {background: #373779;}
    
    .banner_box_swiper_box { position: static; }
    .banner_box_swiper_box .swiper-pagination { bottom: 0px; }
    .banner_box_swiper_box .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: #fff;
      border: 2px solid #373779;
      box-sizing: border-box;
      opacity: 1;
    }
    .banner_box_swiper_box .swiper-pagination-bullet-active {
      background: #373779;
    }

    .slider_banner_box {
      width: 100%;
      height: auto;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
    }
    .slider_banner_box a {
      display: block;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    .slider_banner_box img {
      width: 100%;
      height: 100%;
      display: block;
    }
    /*=====pre_reg_box=====*/
    .pre_reg_box {
      width: 300px;
      min-height: 140px;
      padding: 20px;
      box-sizing: border-box;
      background-image: linear-gradient(to bottom, #6460b1, #5533b1);
      border-radius: 6px;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .pre_reg_box h2 {
      font-size: 26px;
      text-align: left;
      color: #fff;
      margin-bottom: 25px;
      word-break: keep-all;
    }
    .pre_reg_box b {
      display: block;
      font-size: 15px;
      text-align: left;
      color: #fff;
      line-height: 24px;
      margin-bottom: 5px;
    }
    .pre_reg_box p {
      font-size: 15px;
      text-align: left;
      color: #fff;
      line-height: 20px;
      font-weight: normal;
    }
    .banner_box {
      margin-bottom: 30px;
      height: 120px;
      border-radius: 6px;
      overflow: hidden;
    }
    .r_notice{display:flex; flex-direction:column; gap:10px; border:1px solid #e4e4e4; border-radius:6px; padding:20px}
    .r_notice h2 {
      font-size: 16px;
      text-align: left;
      color: #333;
      font-weight:700;
      line-height:24px;
    }
    .r_notice p {
      text-align: left;
      color: #666;
      line-height: normal;
    }
    .r_notice p span {
      display: block;
    }
    /*=========사전등록페이지 모바일가로, 맥북, 탭===========*/
    @media (min-width: 768px) and (max-width: 1023px) {
      .sch_wrap {display: flex; flex-direction:column; row-gap:50px}
      .sch_wrapper {width: 100%;padding-right:0;}
      .bnr_right {width: 100%;}
      .pre_reg_box {width: 100%;}
      .detail_banner_box_con{display:flex; gap:10px;}
      .detail_banner_box_con > div,.detail_banner_box_con .right_banner_box{width:33.33%;}
      .slider_banner_box_con{margin-bottom:0;}
      .slider_banner_box_con_empty{display:block; background:#EBEBF8; border-radius:6px;}
    }
    @media (max-width: 767px) {
      .detail_banner_box_con{display:flex; gap:10px;}
      .detail_banner_box_con > div,
      .slider_banner_box_con,
      .slider_banner_box_con_empty,
      .detail_banner_box_con .right_banner_box{width:50%;}
      .slider_banner_box_con{margin-bottom:0;}
      .slider_banner_box_con_empty:last-child{display:none;}
      .slider_banner_box_con_empty{display:block; background:#EBEBF8; border-radius:6px;}
    }
    @media all and (max-width:479px) {
      .detail_banner_box_con > div,
      .slider_banner_box_con > div,
      .slider_banner_box_con,
      .detail_banner_box_con .right_banner_box,
      .slider_banner_box_con_empty{width:100%;}
      .slider_banner_box_con_empty{display:none;}
    }
    /*======사전등록페이지 모바일======*/
    @media (max-width: 767px) {
      .sch_wrap{flex-direction: column; gap:50px;}
      .sch_wrapper{width:100%; padding-right:0;}
      .bnr_right{width:100%;}
      .sch_wrapper .basic_btn{width:100%;}
      .sch_wrapper .ent_span{margin-top:9px;}
      .hashtag_list li span{font-size:13px; line-height:17px;}
      .sch_section .pre_reg_box { max-width: 800px;width: 100%;margin-bottom: 20px;}
      .pre_reg_box {
        min-height: 140px;
        padding: 20px;
        box-sizing: border-box;
        background-image: linear-gradient(to bottom, #6460b1, #5533b1);
        border-radius: 6px;
        cursor: pointer;
      }
      .pre_reg_box h2 {
        font-size: 20px;
        text-align: left;
        color: #fff;
        margin-bottom: 25px;
      }
      .pre_reg_box b {
        display: block;
        font-size: 15px;
        text-align: left;
        color: #fff;
        line-height: 24px;
        margin-bottom: 5px;
      }
      .pre_reg_box p {
        font-size: 15px;
        text-align: left;
        color: #fff;
        line-height: 20px;
        font-weight: normal;
      }

      .m_banner_box {
        width: 100%;
        max-width: 800px;
        border-radius: 6px;
        height: 190px;
        overflow: hidden;
        margin-bottom:20px;
      }
      .m_banner_box a {
        display: block;
        width: 100%;
        height: 100%;
      }
      .m_banner_box a img {
        width: 100%;
        display: block;
        height: 100%;
      }
      .m_banner_box_swiper_box {
        position: static;
        margin-bottom:20px;
      }
      .m_banner_box_swiper_box .swiper-container {
        padding-bottom: 30px;
      }
      .m_banner_box_swiper_box .swiper-pagination {
        bottom: 0px;
      }
      .m_banner_box_swiper_box .swiper-pagination-bullet {
        width: 12px;
        opacity: 1;
        height: 12px;
        background: #fff;
        border: 2px solid #373779;
        box-sizing: border-box;
      }
      .m_banner_box_swiper_box .swiper-pagination-bullet-active {
        background: #373779;
      }
    
      .m_banner_box2 {
        min-height: 120px;
        background: #f7f7fa;
        margin-bottom: 12px;
    
        border-radius: 6px;
      }
      .m_banner_box_swiper_box2 {
        position: static;
      }
      .m_banner_box_swiper_box2 .swiper-container {
        margin-right: -20px;
      }
    
      .r_notice {
        margin-bottom: 30px;
      }
      .r_notice p span {
        display: inline-block;
        margin-right: 10px;
      }
      .m_slide_con {
        display:none;
        margin-bottom: 20px;
      }
      .m_slide_con .swiper-container {
        position: static;
        margin-right: -20px;
        padding-bottom:0;
      }
      .m_slide_con .swiper-container .swiper-wrapper .swiper-slide{width:auto;}
      .m_slide_con .slide_flex {
        display: flex;
        width: fit-content;
        float: left;
      }
      .m_slide_con .swiper-slide .slide_flex .slide_flex_div {
        position: relative;
        width: 58px;
        height: 58px;
        margin-right: 10px;
      }
      .m_slide_con .swiper-slide .slide_flex .slide_flex_inner_div {
        position: relative;
        width: 58px;
        height: 58px;
      }
      .m_slide_con .swiper-slide .slide_flex .slide_img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .m_slide_con .swiper-slide .slide_flex_t h2 {
        font-size: 15px;
        text-align: left;
        line-height: 1.54;
        color: #333;
      }
      .m_slide_con .swiper-slide .slide_flex_t p {
        font-size: 12px;
        line-height: 1.3;
        text-align: left;
        color: #999999;
      }
      .m_slide_con .swiper-slide .slide_flex_t p span {font-size: 12px;}
      .m_slide_con .swiper-slide .slide_flex_t span {display: block;}
      .sch_section .sch_b_con .timeline_h4 { margin-bottom: 10px;}
      .sch_section .sch_b_con .timeline_h4 span {font-size: 15px;}
      .sch_section .sch_b_con .session_name h5 {font-size: 20px;line-height: 1.4;}
      .sch_section .sch_b_con .session_user_list .more_btn_p{margin-top:0;margin-bottom:20px;}
      .sch_section .sch_b_con .session_user_list > .more_btn_p.on { display: block; margin-top: 10px;}
      .sch_section .pre {width: 100%;}
      .sch_section .ent_span {line-height: 1.71;color: #6a6af8;text-align: center;}
      .sch_section .ent_span .time_b {color: #4e4b7b;}
      .sch_section .ent_span small {color: #666666;}
      .sch_section .basic_btn {width: 100%;font-weight: bold;}
    }

    /*gsk 사전등록페이지*/
    .sch_b_con_flex{display:flex; justify-content: space-between;}
    .sch_b_con_left{width:calc(70% - 20px); display:flex; flex-direction:column; row-gap:20px;}
    .slide_flex .slide_flex_t{padding-top:0px;}
    .sch_b_con_right{width:30%; text-align:right;}
    .sch_wrapper .basic_btn span {display:inline-block; font-size:14px; margin-left:3px;}

    @media (min-width: 768px) and (max-width: 1023px){
      .bnr_right{margin-top:60px;}
    }
    @media (max-width:767px){
      /*gsk 모바일 사전등록 페이지*/
      .sch_b_con_flex{flex-direction: column; row-gap:20px}
      .sch_b_con_left,.sch_b_con_right{width:100%;}
      .sch_b_con_right,.sch_wrapper .ent_span{text-align:center;}
    }
`

export default style
